<template>
  <CModal
    size="lg"
    :show.sync="isAddQueueShow"
    :closeOnBackdrop="false"
    class="CmodalCustom"
  >
    <div class="container bg-tranparent">
      <CCard class="bg-tranparent">
        <CCardBody>
          <CRow
            align-horizontal="center"
            align-vertical="center"
            v-if="isAddQueueShow"
          >
            <CCol
              xl="4"
              lg="4"
              md="12"
              sm="12"
              align-horizontal="center"
              align-vertical="center"
              style="display: flex; justify-content: center"
            >
              <template v-if="point !== null">
                <!-- <template v-if="point ===0"> -->
                <CRow align-horizontal="center" align-vertical="center">
                  <template v-if="CheckWidth >= 2001">
                    <img
                      :src="baseUrl + response.content.image[0].url"
                      width="800px"
                    />
                  </template>
                  <template
                    v-else-if="CheckWidth >= 1501 && CheckWidth <= 2000"
                  >
                    <img
                      :src="baseUrl + response.content.image[0].url"
                      width="500px"
                    />
                  </template>
                  <template v-else-if="CheckWidth <= 1500 && CheckWidth >= 501">
                    <img
                      :src="baseUrl + response.content.image[0].url"
                      width="400px"
                    />
                  </template>
                  <template v-else-if="CheckWidth <= 500">
                    <img
                      :src="baseUrl + response.content.image[0].url"
                      width="300px"
                    />
                  </template>
                  <template v-else>
                    <img
                      :src="baseUrl + response.content.image[0].url"
                      width="400px"
                    />
                  </template>
                </CRow>
                <!-- </template> -->
              </template>
              <template v-else>
                <template v-if="response.content.image.length < 2">
                  <CRow align-horizontal="center" align-vertical="center">
                    <template v-if="CheckWidth >= 2001">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="800px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth >= 1501 && CheckWidth <= 2000"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="500px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth <= 1500 && CheckWidth >= 501"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                    <template v-else-if="CheckWidth <= 500">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="300px"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                  </CRow>
                </template>
                <template v-else-if="checkAnswer === true">
                  <CRow align-horizontal="center" align-vertical="center">
                    <!-- {{this.code}} -->
                    <template v-if="CheckWidth >= 2001">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="800px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth >= 1501 && CheckWidth <= 2000"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="500px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth <= 1500 && CheckWidth >= 501"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                    <template v-else-if="CheckWidth <= 500">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="300px"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                  </CRow>
                </template>
                <template v-else-if="checkAnswer === false">
                  <CRow align-horizontal="center" align-vertical="center">
                    <template v-if="CheckWidth >= 2001">
                      <img
                        :src="baseUrl + response.content.image[1].url"
                        width="800px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth >= 1501 && CheckWidth <= 2000"
                    >
                      <img
                        :src="baseUrl + response.content.image[1].url"
                        width="500px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth <= 1500 && CheckWidth >= 501"
                    >
                      <img
                        :src="baseUrl + response.content.image[1].url"
                        width="400px"
                      />
                    </template>
                    <template v-else-if="CheckWidth <= 500">
                      <img
                        :src="baseUrl + response.content.image[1].url"
                        width="50px"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="baseUrl + response.content.image[1].url"
                        width="400px"
                      />
                    </template>
                  </CRow>
                </template>
                <template v-else>
                  <CRow align-horizontal="center" align-vertical="center">
                    <!-- {{this.code}} -->
                    <template v-if="CheckWidth >= 2001">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="800px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth >= 1501 && CheckWidth <= 2000"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="500px"
                      />
                    </template>
                    <template
                      v-else-if="CheckWidth <= 1500 && CheckWidth >= 501"
                    >
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                    <template v-else-if="CheckWidth <= 500">
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="50px"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="baseUrl + response.content.image[0].url"
                        width="400px"
                      />
                    </template>
                  </CRow>
                </template>
              </template>
            </CCol>
            <CCol
              xl="6"
              lg="7"
              md="12"
              sm="12"
              class="p-4"
              style="display: flex; justify-content: center"
            >
              <CCol
                xl="8"
                lg="8"
                md="12"
                sm="12"
                class="img-container-right pt-2 pb-2 pl-2 pr-2"
              >
                <template v-if="point !== null">
                  <template v-if="point === 0">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-if="checkText"
                      >
                        {{
                          $helpers.translate(
                            response.content.image[0].message,
                            lang
                          )
                        }}
                      </h3>
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-else
                      >
                        {{
                          $helpers.translate(
                            response.content.image[0].message,
                            lang
                          )
                        }}
                      </h3>
                      <!-- <template
                        v-if="
                          checkLanguage(
                            response.content.image[0].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split("#PIN YIN")[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split("#PIN YIN")[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[0].message) }}
                        </h3>
                      </template> -->
                    </CRow>
                  </template>
                  <template v-if="point === 1">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-if="checkText"
                      >
                        {{
                          $helpers.translate(
                            response.content.image[1].message,
                            lang
                          )
                        }}
                      </h3>
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-else
                      >
                        {{
                          $helpers.translate(
                            response.content.image[1].message,
                            lang
                          )
                        }}
                      </h3>
                      <!-- <template
                        v-if="
                          checkLanguage(
                            response.content.image[1].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[1].message
                            ).split("#PIN YIN")[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[1].message
                            ).split("#PIN YIN")[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[1].message) }}
                        </h3>
                      </template> -->
                    </CRow>
                  </template>
                  <template v-if="point === 2">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-if="checkText"
                      >
                        {{
                          $helpers.translate(
                            response.content.image[1].message,
                            lang
                          )
                        }}
                      </h3>
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-else
                      >
                        {{
                          $helpers.translate(
                            response.content.image[2].message,
                            lang
                          )
                        }}
                      </h3>
                      <!-- <template
                        v-if="
                          checkLanguage(
                            response.content.image[2].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[2].message
                            ).split("#PIN YIN")[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[2].message
                            ).split("#PIN YIN")[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[2].message) }}
                        </h3>
                      </template> -->
                    </CRow>
                  </template>
                  <template v-if="point === 3">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-if="checkText"
                      >
                        {{
                          $helpers.translate(
                            response.content.image[1].message,
                            lang
                          )
                        }}
                      </h3>
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-else
                      >
                        {{
                          $helpers.translate(
                            response.content.image[3].message,
                            lang
                          )
                        }}
                      </h3>
                      <!-- <template
                        v-if="
                          checkLanguage(
                            response.content.image[3].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[3].message
                            ).split("#PIN YIN")[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[3].message
                            ).split("#PIN YIN")[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[3].message) }}
                        </h3>
                      </template> -->
                    </CRow>
                  </template>
                  <template v-if="point === 4">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-if="checkText"
                      >
                        {{
                          $helpers.translate(
                            response.content.image[0].message,
                            lang
                          )
                        }}
                      </h3>
                      <h3
                        :class="
                          checkLangClass() + ' content-text line-height-30 '
                        "
                        v-else
                      >
                        {{
                          $helpers.translate(
                            response.content.image[4].message,
                            lang
                          )
                        }}
                      </h3>
                      <!-- <template
                        v-if="
                          checkLanguage(
                            response.content.image[4].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[4].message
                            ).split("#PIN YIN")[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[4].message
                            ).split("#PIN YIN")[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[4].message) }}
                        </h3>
                      </template> -->
                    </CRow>
                  </template>
                </template>

                <!------------------pre test-------------------------->
                <template v-else-if="preTestScore !== null">
                  <template v-if="preTestScore >= 0 && preTestScore <= 25">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[0].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[0].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                  <template v-if="preTestScore >= 26 && preTestScore <= 40">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[1].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[1].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[1].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[1].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                  <template v-if="preTestScore >= 41 && preTestScore <= 50">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[2].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[2].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[2].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[2].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                </template>
                <template v-else>
                  <template v-if="checkAnswer === true">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[0].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[0].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                  <template v-else-if="checkAnswer === false">
                    <template v-if="response.content.image.length < 2">
                      <CRow
                        class="mt-1 mb-1 ml-3 mr-3"
                        align-vertical="center"
                        align-horizontal="center"
                      >
                        <template
                          v-if="
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          "
                        >
                          <h3
                            :class="
                              checkLangClass() + ' content-text line-height-30 '
                            "
                          >
                            {{
                              checkLanguage(
                                response.content.image[0].message
                              ).split('#PIN YIN')[0]
                            }}
                          </h3>
                          <h3 class="content-text line-height-30 fontPinyin">
                            {{
                              checkLanguage(
                                response.content.image[0].message
                              ).split('#PIN YIN')[1]
                            }}
                          </h3>
                        </template>
                        <template v-else>
                          <h3
                            :class="
                              checkLangClass() + ' content-text line-height-30 '
                            "
                          >
                            {{
                              checkLanguage(response.content.image[0].message)
                            }}
                          </h3>
                        </template>
                      </CRow>
                    </template>
                    <template v-else>
                      <CRow
                        class="mt-1 mb-1 ml-3 mr-3"
                        align-vertical="center"
                        align-horizontal="center"
                      >
                        <template
                          v-if="
                            checkLanguage(
                              response.content.image[1].message
                            ).split('#PIN YIN')[1]
                          "
                        >
                          <h3
                            :class="
                              checkLangClass() + ' content-text line-height-30 '
                            "
                          >
                            {{
                              checkLanguage(
                                response.content.image[1].message
                              ).split('#PIN YIN')[0]
                            }}
                          </h3>
                          <h3 class="content-text line-height-30 fontPinyin">
                            {{
                              checkLanguage(
                                response.content.image[1].message
                              ).split('#PIN YIN')[1]
                            }}
                          </h3>
                        </template>
                        <template v-else>
                          <h3
                            :class="
                              checkLangClass() + ' content-text line-height-30 '
                            "
                          >
                            {{
                              checkLanguage(response.content.image[1].message)
                            }}
                          </h3>
                        </template>
                      </CRow>
                    </template>
                  </template>
                  <template v-else-if="response.content.image.length < 2">
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[0].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[0].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                  <template v-else>
                    <CRow
                      class="mt-1 mb-1 ml-3 mr-3"
                      align-vertical="center"
                      align-horizontal="center"
                    >
                      <template
                        v-if="
                          checkLanguage(
                            response.content.image[0].message
                          ).split('#PIN YIN')[1]
                        "
                      >
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[0]
                          }}
                        </h3>
                        <h3 class="content-text line-height-30 fontPinyin">
                          {{
                            checkLanguage(
                              response.content.image[0].message
                            ).split('#PIN YIN')[1]
                          }}
                        </h3>
                      </template>
                      <template v-else>
                        <h3
                          :class="
                            checkLangClass() + ' content-text line-height-30 '
                          "
                        >
                          {{ checkLanguage(response.content.image[0].message) }}
                        </h3>
                      </template>
                    </CRow>
                  </template>
                </template>
                <CRow align-vertical="center" align-horizontal="center">
                  <CButton
                    @click="onNext(response.navigate?.next?.action)"
                    color="success"
                    shape="pill"
                    size="lg"
                    class="mt-3 pl-5 pr-5"
                    >{{ checkLanguage(response.navigate.next.title) }}</CButton
                  >
                </CRow>
              </CCol>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  </CModal>
</template>

<script>
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseModalCustom.scss';
export default {
  components: {},
  name: 'PopupIntroCModal',
  props: {
    //content: Object,
    response: Object,
    // cardContentData: Object,
    isAddQueueShow: Boolean,
    // openModal: Function,
    CheckWidth: String,
    code: String,
    checkAnswer: Boolean,
    point: Number,
    preTestScore: Number,
    checkText: Boolean,
    funcRoute: Function,
  },
  data() {
    return {
      lang: '',
      startTime: null,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      path: '',
      str: [],
    };
  },

  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      getCheckAnswerResult: 'template/getCheckAnswerResult',
    }),
  },

  watch: {
    point: function (val) {
      alert(val);
    },
    checkAnswer: function (val) {},
    // allCourse: function (val) {
    //   this.response = val;
    // },
    storeLanguage: function (val) {
      this.lang = val;
    },
    isAddQueueShow: function (val) {
      if (this.isAddQueueShow) {
        this.$store.dispatch('template/fetchContent', this.code);
      }
    },
    getCheckAnswerResult: function (val) {
      var getPoint = this.$store.getters['necessary/getTmpScore'];
      if (this.checkText && getPoint < 4) {
        if (this.response.codeTemplate == 'LKT01-65') {
          this.$router.push('/IAM05/335');
        } else if (this.response.codeTemplate == 'LKT01-66') {
          this.$router.push('/IAM05/339');
        }
      } else if (this.str[0] === 'LKT01') {
        let body = {};
        body.code = this.$store.getters['necessary/getLerningCourse']._id;
        body.templateCode = this.temporaryId;
        this.$store.dispatch('template/fetchContent', body);
        this.$router.push(this.path);
      } else {
        this.$router.push(this.path);
      }
    },
  },

  mounted() {},

  created() {
    this.lang = this.$store.getters['language/getLanguage'];
    this.startTime = this.$helpers.getDateFormat();
    // console.log(this.response.content.image[1].message, 'message');
    // console.log(this.response.content.image.length, 'content image length');
    // console.log(this.checkAnswer, 'check answer');

    // console.log(this.response, 'response');
    // console.log(this.point, 'point');
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    onNext(path) {
      // this.str = tempId.split('-');
      // this.temporaryId = tempId;
      // this.path = '/' + this.str[0] + '/' + this.str[1];
      // let courseSection =
      //   this.$store.getters['necessary/getLerningCourse'].groups[0].code;
      // this.$store.commit('necessary/setCodePage', this.str[1]);
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.$store.getters['necessary/getLerningCourse']._id,
      //   template: this.response._id,
      //   section: courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: [],
      // });
      // this.$router.push(`/display/${tempId}`);

      this.$emit('funcRoute', path);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
  },
};
</script>

<style scoped>
.line-height-30 {
  line-height: 30px;
}

.bg-tranparent {
  background-color: transparent;
  border: 0px;
}

.img-container-tranparent {
  background-color: transparent;
  width: 100%;
  font-size: 80px;
  border-radius: 10px;
}

.img-container-right {
  justify-content: flex-start;
  background-color: #ffffff;
  border-radius: 10px;
}
</style>
